<p>
  manage-roles works!
</p>
